import React from 'react';
import { css } from '@emotion/react';

import { ButtonStyled, classes } from '@eto/eto-ui-components';

import Hashtag from "../images/Hashtag.inline.svg";

const styles = {
  toolCard: css`
    --toolcard-right-padding: 15px;
    background-color: var(--bright-blue-lightest);
    border-left: 1px solid var(--bright-blue);
    color: var(--dark-blue);
    display: grid;
    font-family: GTZirkonLight;
    grid-template-columns: 40px 1fr;
    grid-template-rows: min-content 25px 40px 1fr 40px 40px;
    min-width: 300px;
  `,
  corner: css`
    background-color: var(--bright-blue-light);
    grid-column: 1;
    grid-row: 1;
  `,
  title: css`
    background-color: var(--bright-blue-light);
    display: flex;
    font-family: GTZirkonMedium;
    font-size: 125%;
    grid-column: 2;
    grid-row: 1;
    margin: 0;

    a {
      padding: 15px 0;
      padding-right: var(--toolcard-right-padding);
      text-decoration: none;
      width: 100%;
    }
  `,
  hashtag: css`
    align-items: center;
    background-color: var(--bright-blue);
    display: flex;
    grid-column: 1;
    grid-row: 2;

    svg {
      height: 18px;
      margin: 0 auto;
    }
  `,
  tags: css`
    display: flex;
    flex-wrap: wrap;
    grid-column: 2;
    grid-row: 2;
    height: 24px;

    & > * {
      align-items: center;
      background-color: var(--bright-blue-lighter);
      border-right: 1px solid var(--bright-blue);
      display: flex;
      font-family: GTZirkonMedium;
      font-size: 75%;
      padding: 5px 15px;
    }
  `,
  description: css`
    grid-column: 2;
    grid-row: 4;
    padding-right: var(--toolcard-right-padding);
  `,
  buttonWrapper: css`
    display: flex;
    grid-column: 1 / -1;
    grid-row: -2 / -1;
    justify-content: space-evenly;
  `,
  button: css`
    &.eto-button {
      background-color: var(--bright-blue-light);
      color: var(--dark-blue);
      font-family: GTZirkonMedium;
      font-size: 80%;
      width: 100%;

      & + & {
        border-left: 1px solid var(--bright-blue);
      }
    }
  `,
};

const ResourceCard = ({
  className: appliedClassName = undefined,
  css: appliedCss = undefined,
  id: appliedId = undefined,
  data,
  documentationButtonText = "User guide",
}) => {
  return (
    <div
      className={classes("datasetcard", appliedClassName)}
      css={[styles.toolCard, appliedCss]}
      id={appliedId}
    >
      <div css={styles.corner}></div>
      <h3 css={styles.title}>
        <a href={data.url} target="_blank" rel="noopener">
          {data.name}
        </a>
      </h3>
      <div css={styles.hashtag}>
        <Hashtag />
      </div>
      <div css={styles.tags}>
        {(data?.tags ?? []).map(tag => <div key={tag}>{tag}</div>)}
      </div>
      <div css={styles.description}>{data.description}</div>
      <div css={styles.buttonWrapper}>
        {data.url !== data.documentationUrl &&
          <ButtonStyled
            css={styles.button}
            href={data.url}
            target="_blank"
            rel="noopener"
          >
            Launch tool
          </ButtonStyled>
        }
        <ButtonStyled
          css={styles.button}
          href={data.documentationUrl}
          target="_blank"
          rel="noopener"
        >
          {documentationButtonText}
        </ButtonStyled>
      </div>
    </div>
  );
};

export default ResourceCard;
